import React, { Component } from 'react'
import Switch from "react-switch";
import firebase from '../../config/database';


/**
 * Create pager and delete action for Firebase 
 * 
 * Available props
 * isLastPage
 * goPrevious
 * page
 * goNext
 * deleteFieldAction
 * 
 */


export default class Pager extends Component {

  constructor() {
    super();
    
    this.state = { checked: false };
    this.handleChange = this.handleChange.bind(this);
    this.sendData = this.sendData.bind(this);
    
    
  }

  handleChange(checked) {
    this.setState({ checked:checked });
    this.sendData(this.state.checked);
    
  }

  sendData(isPublished){
    this.props.isPublishedCallback(isPublished);
    
}
  render() {
    console.log('props', this.props);
    let chkPathName = (this.props.firebasePath).substring(0,10);
    console.log('check firebasepath', chkPathName);
    
    return (
      <div className="col-md-12">
        <div className="card">
          <form className="form-horizontal">
            <div className="col-md-12">
              <div className="col-md-6">
                <button style={{ opacity: this.props.isLastPage ? 0.3 : 1 }} onClick={() => { this.props.goPrevious() }} className="btn">
                  <span className="btn-label">
                    <i className="material-icons">keyboard_arrow_left</i>
                  </span>
                  Previous
                      <div className="ripple-container"></div>
                </button>
                <button style={{ opacity: this.props.page > 1 ? 1 : 0.3 }} onClick={() => { this.props.goNext() }} className="btn">
                  Next
                      <span className="btn-label">
                    <i className="material-icons">keyboard_arrow_right</i>
                  </span>
                  <div className="ripple-container"></div>
                </button>
              </div>
             
              
              { (chkPathName == 'newSection')?
                <div className="col-md-3" style={{ padding: '15px 0 10px 0', float:'right'}}>
                <label style={{float:'right'}}>
                 Publish&nbsp;&nbsp;
                 <span style={{verticalAlign: 'middle'}}>
                   <Switch onChange={this.handleChange} checked={this.props.isChecked} /></span>
                </label>
              </div> : <div className="col-md-3" style={{padding: '10px 0 15px 0',float:'right'}}>
                <label style={{float:'right',
                backgroundColor:'#00b359',
                color:'#ffffff',
                lineHeight:'40px',
                verticalAlign: 'middle',
                padding:'0 10px 0 10px'}}>
                  PUBLISHED SECTION</label>
              </div>              
              }
              { (chkPathName == 'newSection')?  <div className="col-md-3" style={{float:'right'}}>
                <a onClick={() => { this.props.deleteFieldAction(null, false) }} className="btn btn-danger pull-right">Delete Element</a>
              </div> : <div className="col-md-3" style={{float:'right'}}></div>}
              

            </div>

          </form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/template/Pager.js